import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b6ca83f4&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "vue-pnotify/dist/vue-pnotify.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=b6ca83f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports